<template>
  <div class="animated fadeIn">
    <SubHeaderDraft />
    <DataTable :editable="editable" :eventStatus="eventStatus"/>
  </div>
</template>

<script>
import data from '../_data';
import SubHeaderDraft from '../components/subHeaders/SubHeaderDraft';
import DataTable from '../components/datatable/DataTable';
import consts from '../_consts'
import {mapGetters, mapActions} from 'vuex';

export default {
  name: 'drafts',
  components: {
    SubHeaderDraft,
    DataTable
  },
  data () {
    return {
      list: data.items,
      userRole: data.currentUser.role,
      currentPage: 1,
      perPage: 5,
      totalRows: data.items.length,
      pageOptions: [
        { text: 5, value: 5 },
        { text: 10, value: 10 },
        { text: 15, value: 15 }
      ],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' },
      eventStatus: consts.EVENT_TYPES.drafts.text
    };
  },
  computed: {
    enableSubHeaderDraft (enable = false) {
      if (this.userRole === 'user' || enable === true) {
        return true;
      }
      return false
    },
    editable () {
      // userRole = localStorage.getItem(consts.LOCAL_STORE.role);
      return true;
    },
    ...mapGetters({
      getFlagCreateEvent: 'GETTERS_CREATE_EVENT_FLAG',
      submitAllEventSuccess: 'GETTERS_SUBMIT_ALL_EVENT_SUCCESS'
    })
  },
  methods: {
    details (item, index, button) {
      this.modalDetails.data = JSON.stringify(item, null, 2);
      this.modalDetails.index = index;
      this.$root.$emit('show::modal', 'modal1', button);
    },
    resetModal () {
      this.modalDetails.data = '';
      this.modalDetails.index = '';
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    ...mapActions({
      createNewEvent: 'ACTION_CREATE_NEW_EVENT',
      setShowModalSubmitAllEventSuccess: 'ACTION_SET_SUBMIT_ALL_EVENT_SUCCESS',
      setExpandId: 'ACTION_SET_EXPAND_ID'
    })
  },
  watch: {
    getFlagCreateEvent: {
      handler: function () {
        if (this.getFlagCreateEvent === true) {
          this.createNewEvent();
          this.setExpandId({id: 0, isExpand: true});
        }
      },
      deep: true
    },
    submitAllEventSuccess: {
      handler: function () {
        if (this.submitAllEventSuccess === false) {
          let modalData = {
            action: consts.modalAction.submitAllEventError,
            data: null
          };
          this.$modal.show('eventModal', modalData);
          this.setShowModalSubmitAllEventSuccess(true);
        }
      },
      deep: true
    }
  }
};
</script>
<style>
.textHeader {
  height: 17px;
  width: 37px;
  color: #FFFFFF;
  font-family: 'Open Sans', sans-serif;
  font-size: 10px;
  line-height: 17px;
}

tbody {
  background-color: #ffffff;
}

.table thead th {
  height: 37px;
  background-color: #231F20;
}

table.b-table tfoot>tr>.sorting:after,
table.b-table tfoot>tr>.sorting:before,
table.b-table thead>tr>.sorting:after,
table.b-table thead>tr>.sorting:before {
  background-color: #ffffff;
}

table.b-table>tfoot>tr>.sorting:after,
table.b-table>thead>tr>.sorting:after {
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// Drafts.vue?68449c01